"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/components/Extension/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_dynamicTag = require("marko/dist/runtime/helpers/dynamic-tag");

function render(input, out, __component, component, state) {
  var data = input;

  marko_dynamicTag(out, window.FedExtLoader.marko, function() {
    return input;
  }, null, null, null, __component, "NRI-Key-" + (++window.FedExtLoader.key), [
    [
      "forward",
      ( ...args ) => component.emit( ...args ),
      false
    ]
  ]);
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
